import React from "react";

const ChevronDownIcon = ({ className = "w-3.5 h-2" }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      className={className}
      fill="currentColor"
    >
      <path d="M6.54564 5.09128L11.6369 0L13.0913 1.45436L6.54564 8L0 1.45436L1.45436 0L6.54564 5.09128Z" />
    </svg>
  );
};

export default ChevronDownIcon;
